/* ============================================================================
   Joe's Kitchen — Dark "Crave" Home page interactions
   Wires Dish of the Week (size + qty + add) and Crowd Favorites (size + add)
   to the real Shopify cart via window.JK (jk-chrome.js). Markup is rendered by
   the Liquid sections; size pills carry data-variant-id + data-price (cents).
   ============================================================================ */
(function () {
  const money = (cents) => (window.JK && window.JK.money ? window.JK.money(cents) : '$' + (cents / 100).toFixed(2));

  function initDow(root) {
    const sizes = root.querySelectorAll('.dow-size');
    const priceEl = root.querySelector('.dow-price');
    const qtyEl = root.querySelector('.dow-qty .q');
    const dec = root.querySelector('.dow-qty .dec');
    const inc = root.querySelector('.dow-qty .inc');
    const addBtn = root.querySelector('.dow-add');
    if (!addBtn) return;
    let qty = 1;
    const active = () => root.querySelector('.dow-size.active') || sizes[0];
    const refresh = () => {
      if (qtyEl) qtyEl.textContent = qty;
      if (dec) dec.classList.toggle('disabled', qty <= 1);
      const a = active();
      if (priceEl && a) priceEl.textContent = money(parseInt(a.dataset.price, 10) * qty);
    };
    sizes.forEach((s) => s.addEventListener('click', () => {
      sizes.forEach((x) => x.classList.toggle('active', x === s));
      refresh();
    }));
    if (inc) inc.addEventListener('click', () => { qty++; refresh(); });
    if (dec) dec.addEventListener('click', () => { if (qty > 1) { qty--; refresh(); } });
    addBtn.addEventListener('click', () => {
      const a = active();
      if (!a || !window.JK) return;
      addBtn.disabled = true;
      window.JK.add(a.dataset.variantId, qty)
        .then(() => { window.JK.openDrawer(); })
        .catch((e) => { alert(e.message || 'Could not add to cart'); })
        .finally(() => { addBtn.disabled = false; });
    });
    refresh();
  }

  function initFav(card) {
    const sizes = card.querySelectorAll('.fav-size');
    const priceEl = card.querySelector('.fav-price');
    const addBtn = card.querySelector('.fav-add');
    const lbl = addBtn ? addBtn.querySelector('.lbl') : null;
    if (!addBtn) return;
    const active = () => card.querySelector('.fav-size.active') || sizes[0];
    sizes.forEach((s) => s.addEventListener('click', (e) => {
      e.stopPropagation();
      sizes.forEach((x) => x.classList.toggle('active', x === s));
      if (priceEl) priceEl.textContent = money(parseInt(s.dataset.price, 10));
    }));
    addBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!window.JK) return;
      const a = active();
      const variantId = a ? a.dataset.variantId : card.dataset.defaultVariant;
      if (!variantId) return;
      addBtn.disabled = true;
      window.JK.add(variantId, 1)
        .then(() => {
          card.classList.add('added');
          if (lbl) {
            const prev = lbl.textContent;
            lbl.textContent = 'Added';
            clearTimeout(addBtn._t);
            addBtn._t = setTimeout(() => { lbl.textContent = prev || 'Add to Order'; }, 1100);
          }
        })
        .catch((err) => { alert(err.message || 'Could not add to cart'); })
        .finally(() => { addBtn.disabled = false; });
    });
  }

  function init() {
    document.querySelectorAll('.dow-info').forEach(initDow);
    document.querySelectorAll('.fav-card').forEach(initFav);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
